// src/components/Campaigns/DonationsList.jsx
import React from "react";
import {
  Box,
  Typography,
  CircularProgress,
  List,
  ListItem,
  ListItemText,
  Divider,
} from "@mui/material";
import COLORS from "../../../../../constants/colors"; // Ensure this path is correct
import { formatCurrency, formatDate } from "./campaignsUtils"; // Assuming formatDate is available

const DonationsList = ({ donations, loading }) => {
  if (loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: 150 }}>
        <CircularProgress size={30} />
        <Typography variant="body2" color="text.secondary" sx={{ ml: 2 }}>
          Loading donations...
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ mt: 3, p: 2, border: `1px solid ${COLORS.border}`, borderRadius: 2, backgroundColor: '#fdfdfd' }}>
      <Typography variant="h6" fontWeight="bold" sx={{ mb: 1, color: COLORS.primary }}>
        Donations Received ({donations.length})
      </Typography>

      {donations.length === 0 ? (
        <Typography variant="body2" color="text.secondary" sx={{ textAlign: "center", py: 3 }}>
          No donations recorded for this campaign yet.
        </Typography>
      ) : (
        <List sx={{ maxHeight: 150, overflowY: 'auto' }}> {/* Added scroll for many donations */}
          {donations.map((donation, index) => (
            <React.Fragment key={donation.id || index}> {/* Use unique ID if available, else index */}
              <ListItem
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "flex-start",
                  py: 0,
                  px: 0,
                }}
              >
                <ListItemText
                  primary={
                    <Typography variant="body2" fontWeight="medium" sx={{ color: '#333' }}>
                      {donation.donor_name || "Anonymous Donor"}
                    </Typography>
                  }
                  secondary={
                    <Typography variant="caption" color="text.secondary">
                      {formatDate(donation.donated_at)} {/* Assuming 'donated_at' field */}
                    </Typography>
                  }
                  sx={{ flexGrow: 1 }}
                />
                <Typography variant="body2" fontWeight="bold" sx={{ color: COLORS.success, ml: 2, whiteSpace: 'nowrap' }}>
                  {formatCurrency(donation.amount)}
                </Typography>
              </ListItem>
              {index < donations.length - 1 && <Divider component="li" />}
            </React.Fragment>
          ))}
        </List>
      )}
    </Box>
  );
};

export default DonationsList;